'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appNames = require('../constants/appNames');

var _appNames2 = _interopRequireDefault(_appNames);

var _TrackingPixelUtils = require('tracking-pixels/TrackingPixelUtils');

var _TrackingPixelUtils2 = _interopRequireDefault(_TrackingPixelUtils);

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _isApp = require('../utils/isApp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var userCreated = _ref.userCreated,
      hubId = _ref.hubId;

  if ((0, _isApp.isApp)(_appNames2.default.crmSignup)) {
    _TrackingPixelUtils2.default.trackCreatedPortal();
  }
  // this events collect the three legacy events (created/ created new user/ created existing user using the newUser property)
  (0, _AnalyticsActions.trackEvent)('portalCreated', {
    action: 'portal created',
    portalId: hubId,
    newUser: userCreated
  });
};

module.exports = exports['default'];